import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LINHVUC } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { LINHVUC_API } from '../../utils/apiUrl';

// Lấy danh sách tất cả LinhVuc
export const linhVucGetAllAction = createAsyncThunk(
    LINHVUC.GET_ALL,
    async () => {
        return Get(LINHVUC_API.GET_ALL)
            .then(response => response)
            .catch(error => error);
    }
);

// Lấy thông tin 1 LinhVuc theo id
export const linhVucGetItemAction = createAsyncThunk(
    LINHVUC.GET_ITEM,
    async (id) => {
        return Get(LINHVUC_API.GET_ITEM(id))
            .then(response => response)
            .catch(error => error);
    }
);

// Thêm LinhVuc mới
export const addLinhVucAction = createAsyncThunk(
    LINHVUC.ADD_LINHVUC,
    async (model) => {
        return Post(LINHVUC_API.ADD_ITEM, null, model, false)
            .then(response => response.status)
            .catch(error => error);
    }
);

// Sửa LinhVuc
export const editLinhVucAction = createAsyncThunk(
    LINHVUC.EDIT_LINHVUC,
    async (model) => {
        return Put(LINHVUC_API.UPDATE_ITEM(model.id), null, model.data)
            .then(response => response.status)
            .catch(error => error);
    }
);

// Xóa LinhVuc
export const deleteLinhVucAction = createAsyncThunk(
    LINHVUC.DELETE_LINHVUC,
    async (id, { rejectWithValue, fulfillWithValue }) => {
        return DeleteSingle(LINHVUC_API.DELETE_ITEM(id))
            .then(async response => {
                if (response.status === 200) return fulfillWithValue(response.status);
                return rejectWithValue(await response.json());
            })
            .catch(error => error);
    }
);

// State ban đầu
const initialState = {
    listLinhVuc: [],
    linhVucItem: null
};

// Slice ——— đổi tên thành linhvucSlice để import đúng
export const linhvucSlice = createSlice({
    name: LINHVUC.NAME_SLICE,
    initialState,
    reducers: {
        filterListLinhVuc: (state, action) => {
            state.listLinhVuc = state.listLinhVuc.length > 0
                ? state.listLinhVuc.filter(x => x.id !== action.payload)
                : [];
        }
    },
    extraReducers: (builder) => {
        builder
            // GetAll
            .addCase(linhVucGetAllAction.fulfilled, (state, action) => {
                state.listLinhVuc = action.payload || [];
            })

            // GetItem
            .addCase(linhVucGetItemAction.fulfilled, (state, action) => {
                state.linhVucItem = action.payload;
            })
            .addCase(linhVucGetItemAction.rejected, (state) => {
                state.linhVucItem = null;
            });
    }
});

export const { filterListLinhVuc } = linhvucSlice.actions;

// export default reducer
export default linhvucSlice.reducer;
